module.exports = __webpack_public_path__ + "static/media/pedal-row.5ded0c4c.jpg";